import React from 'react';
import { StyledAppRadioReversed } from './index.styled';
import { AppRadioProps } from '../AppRadio';

type AppRadioReversed = AppRadioProps;

const AppRadioReversed: React.FC<AppRadioReversed> = ({ ...props }) => (
  <StyledAppRadioReversed {...props} />
);

export default AppRadioReversed;
